;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputSignature', inputSignature)

  /* @ngInject */
  function inputSignature () {
    return {
      restrict: 'EA',
      scope: {
        model: '=',
        value: '<',
        count: '<',
        disabled: '<',
        readOnly: '<',
        change: '='
      },
      templateUrl: '/core/directives/input-signature/input-signature-directive.html?$$REVISION$$',
      controller: 'InputSignatureController'
    }
  }
})()
